import { getBriefConfig, updateBriefConfig } from '@/api/project-task/setting'
import { transformNewLoading } from '@/assets/js/el-loading'
const SettingKeys = ['showIdCardPhotoToInvestigator','showNoCriminalToInvestigator','showSignToInvestigator','showUserInfoToInvestigator']
export default {
  data() {
    return {
      enabledConfig: null,
      enableLoading: false,
      loading: false,
      briefId: null,
      model: {
        active: false,
        briefTitle: '',
        briefContent: '',
        showIdCardPhotoToInvestigator: false,
        showNoCriminalToInvestigator: false,
        showSignToInvestigator: false,
        showUserInfoToInvestigator: false
      }
    }
  },
  methods: {
    getConfig() {
      this.loading = true
      getBriefConfig(this.projectId, this.briefType).then(res => {
        this.loading = false
        const data = res.data.data
        this.enabledConfig = !!data
        if (data) {
          this.briefId = data.briefId
          Object.keys(this.model).forEach(key => {
            this.model[key] = data[key]
          })
          this.initWatcher()
        }
      }).finally(() => {

      })
    },
    openTask() {
      this.enableLoading = true
      const data = SettingKeys.reduce((acc, cur) => {
        acc[cur] = true
        return acc
      }, {
        ...this.model,
        active: true
      })
      updateBriefConfig(this.projectId, null, this.briefType, data).then(() => {
        this.getConfig()
      }).finally(() => {
        this.enableLoading = false
      })
    },
    initWatcher() {
      this.uws = Object.keys(this.model).map(key => {
        return this.$watch(`model.${key}`, (val, oldVal) => {
          if (SettingKeys.includes(key)) {
            if (SettingKeys.every(k => this.model[k] === false)) {
              this.destroyWatcher()
              this.model[key] = oldVal
              this.initWatcher()
              this.$message.warning("至少开启一项配置")
              return
            }
          }
          transformNewLoading('正在保存',
            updateBriefConfig(this.projectId, this.briefId, this.briefType, {
              ...this.model,
              [key]: val
            }).then(res=>{
              this.briefId = res.data.data
            }).catch(()=>{
              this.destroyWatcher()
              this.model[key] = oldVal
              this.initWatcher()
            })
          )
        })
      })
    },
    destroyWatcher(){
      this.uws.forEach(u => u())
      this.uws = []
    }
  },
  created() {
    this.uws = []
    this.getConfig()
  },
  beforeDestroy() {
    this.destroyWatcher()
  }
}
